import { getMileageAmount, getStaffTimeAmount } from './transportUtils';

export const _setNewTransportForm = (state, action) => {
  state.newTransportForm = action.payload;
};

export const _setFundingSTOPBilltoOrganization = (state, action) => {
  state.fundingSTOPBilltoOrganization = action.payload;
};
export const _setDepartingSAPorJailDepartureLocation = (state, action) => {
  state.departingSAPorJailDepartureLocation = action.payload;
};

export const _setOrganizationPerformingPickUpInitial = (state, action) => {
  state.organizationPerformingPickUpInitial = action.payload;
};

export const _setCommunityProviderFacility = (state, action) => {
  state.communityProviderFacility = action.payload;
};

export const _setFundingSTOPContact = (state, action) => {
  state.fundingSTOPContact = action.payload;
};

export const _setSAPTransitionalCounselor = (state, action) => {
  state.SAPTransitionalCounselor = action.payload;
};

export const _setPersonPerformingPickInitialDeparture = (state, action) => {
  state.personPerformingPickInitialDeparture = action.payload;
};

export const _setPersonReceivingDestination = (state, action) => {
  state.personReceivingDestination = action.payload;
};

export const _setSource = (state, action) => {
  state.source = action.payload;
};

export const _setHighControl = (state, action) => {
  state.highControl = action.payload;
};

export const _setSpecialTransport = (state, action) => {
  state.specialTransport = action.payload;
};

export const _setPlanIncludesFlight = (state, action) => {
  state.planIncludesFlight = action.payload;
};

export const _setSASCARepresentativeTransportationCoordinator = (
  state,
  action
) => {
  state.SASCARepresentativeTransportationCoordinator = action.payload;
};

export const _setTransportCompletedByOrganization = (state, action) => {
  state.transportCompletedByOrganization = action.payload;
};

export const _setInitialDepartureDate = (state, action) => {
  state.initialDepartureDate = action.payload;
};

export const _setDateSAPConfirmedRelease = (state, action) => {
  state.dateSAPConfirmedRelease = action.payload;
};

export const _setSAPStaffConfirmingRelease = (state, action) => {
  state.SAPStaffConfirmingRelease = action.payload;
};

export const _setActualDepartureDate = (state, action) => {
  state.actualDepartureDate = action.payload;
};

export const _setOutcome = (state, action) => {
  state.outcome = action.payload;
};

export const _setWhoContactedConfirmationCallmadeto = (state, action) => {
  state.whoContactedConfirmationCallmadeto = action.payload;
};

export const _setContactedByConfirmationCallmadeby = (state, action) => {
  state.contactedByConfirmationCallmadeby = action.payload;
};

export const _setCallDate = (state, action) => {
  state.callDate = action.payload;
};

export const _setCallTime = (state, action) => {
  state.callTime = action.payload;
};

export const _setStaffTime1By4hrs = (state, action) => {
  state.staffTime1By4hrs = action.payload;
};

export const _setMileage = (state, action) => {
  state.mileage = action.payload;
};

export const _setEstimatedICDTPFlatFee = (state, action) => {
  state.estimatedICDTPFlatFee = action.payload;
};

export const _setStaffTimeQty = (state, action) => {
  state.StaffTimeQty = action.payload;
  state.staffTimeAmount = getStaffTimeAmount(
    state.StaffTimeQty,
    state.mileageRate,
    state.staffTimeOverTime
  );
};

export const _setStaffTimeOverTime = (state, action) => {
  state.staffTimeOverTime = action.payload;
  state.staffTimeAmount = getStaffTimeAmount(
    state.StaffTimeQty,
    state.mileageRate,
    state.staffTimeOverTime
  );
};

export const _setStaffTimeRate = (state, action) => {
  state.staffTimeRate = action.payload;
  state.mileageAmount = getMileageAmount(state.mileageQty, state.staffTimeRate);
};

export const _setStaffTimeAmount = (state, action) => {
  state.staffTimeAmount = action.payload;
};

export const _setMileageQty = (state, action) => {
  state.mileageQty = action.payload;
  state.mileageAmount = getMileageAmount(state.mileageQty, state.staffTimeRate);
};

export const _setMileageRate = (state, action) => {
  state.mileageRate = action.payload;
  state.staffTimeAmount = getStaffTimeAmount(
    state.StaffTimeQty,
    state.mileageRate,
    state.staffTimeOverTime
  );
};

export const _setMileageAmount = (state, action) => {
  state.mileageAmount = action.payload;
};

export const _setICDTPFlatFee = (state, action) => {
  state.ICDTPFlatFee = action.payload;
};

export const _setTotalCombinedActualCosts = (state, action) => {
  state.totalCombinedActualCosts = action.payload;
};

export const _setComments = (state, action) => {
  state.comments = action.payload;
};

export const _setVoid = (state, action) => {
  state.Void = action.payload;
};
